/**
 * Created by joshua on 12/7/16.
 */
import { Injectable } from '@angular/core';


import { environment } from '../../../../environments/environment';
import { Util } from '../../../utils/util.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class RevisionService {
  // API path
  lambdaUserBaseUrl: string;

  #defaultHeaders: HttpHeaders = new HttpHeaders( {
    'Content-Type': 'application/json',
  } );

  constructor( private _http: HttpClient ) {
    this.lambdaUserBaseUrl = `${ environment.ripsawAPIBaseUrl }/workspace-revisions`;
  }

  createRevision( revision: any ): Observable<any> {
    const url: string = `${ this.lambdaUserBaseUrl }/create`;
    return this._http.post( url, revision, { headers: this.#defaultHeaders } )
      .pipe(
        map( Util.extractData ),
        catchError( Util.handleError ),
      );
  }

  getRevisions(): Observable<any> {
    const url: string = `${ this.lambdaUserBaseUrl }/getAll`;
    return this._http.get( url, { headers: this.#defaultHeaders } )
      .pipe(
        map( Util.extractData ),
        catchError( Util.handleError ),
      );
  }

  getActiveRevision( revisionSessionId: number ): Observable<any> {
    const url: string = `${ this.lambdaUserBaseUrl }/by-chat-session/${ revisionSessionId }`;

    return this._http.get( url, { headers: this.#defaultHeaders } )
      .pipe( map( Util.extractData ),
        catchError( Util.handleError ),
      );
  }

  updateRevision( revision: any ): Observable<any> {
    const url: string = `${ this.lambdaUserBaseUrl }/update/${ revision.id }`;
    return this._http.put( url, revision, { headers: this.#defaultHeaders } )
      .pipe(
        map( Util.extractData ),
        catchError( Util.handleError ),
      );
  }

  deleteRevision( revision: any ): Observable<any> {
    const url: string = `${ this.lambdaUserBaseUrl }/remove/${ revision.id }`;
    return this._http.delete( url, { headers: this.#defaultHeaders } )
      .pipe(
        map( Util.extractData ),
        catchError( Util.handleError ),
      );
  }

}
